import { ReactNode } from "react";

export type DeepPartial<T> = T extends object
  ? {
      [P in keyof T]?: DeepPartial<T[P]>;
    }
  : T;

export type AppThemeConfig = DeepPartial<{
  colors: {
    neutral: {
      lighter: string;
      light: string;
      regular: string;
      dark: string;
      darker: string;
    };
    primary: {
      lighter: string;
      light: string;
      regular: string;
      dark: string;
      darker: string;
      secondary: string;
      tertiary: string;
    };
    success: {
      lighter: string;
      light: string;
      regular: string;
      dark: string;
      darker: string;
    };
    highlight: {
      lighter: string;
      light: string;
      regular: string;
      dark: string;
      darker: string;
    };
    error: {
      lighter: string;
      light: string;
      regular: string;
      dark: string;
      darker: string;
    };
    warning: {
      lighter: string;
      light: string;
      regular: string;
      dark: string;
      darker: string;
    };
    gradient: {
      gradientStart?: string;
      gradientEnd?: string;
      gradientOpacityStart?: string;
      gradientOpacityEnd?: string;
      gradientCalculatorOpacityStart?: string;
      gradientCalculatorOpacityEnd?: string;
    };
  };
  borderRadius: {
    default: string;
    checkbox: string;
    modal: string;
    card: string;
    alert: string;
  };
  font: {
    default: string;
  };
}>;

export type AppOptions = {
  theme?: AppThemeConfig;
  name?: string;
  logoUrl?: string;
};

export type LaunchSDKArgs = {
  clientId: string;
  sessionToken: string;
  options?: AppOptions;
  onApplicationStarted?: (loanApplicationId: string) => void;
  onApplicationCompleted?: (loanApplicationId: string) => void;
  onApplicationError?: (loanApplicationId: string, error: Error) => void;
};

export type DisplayFormatMapper<T> = {
  [k in keyof T]?: (value: T[k] | undefined) => ReactNode;
};

export enum InterestFrequency {
  DAILY = "DAILY",
  MONTHLY = "MONTHLY",
  ANNUALLY = "ANNUALLY",
}
